/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const bookmark_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.32 22.77 12 18.344 5.68 22.77a.75.75 0 0 1-1.18-.614V2.595a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v19.56a.75.75 0 0 1-1.18.614Z"
      clipRule="evenodd"
    />
  </svg>
)
export default bookmark_medium
